import { Navigate } from "react-router-dom";
import AddDepartment from "./AddDepartment";

const Department = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<div className="add-department-page-wrapper">
			<AddDepartment />
		</div>
	);
};

export default Department;
